import React from 'react'
import { Box } from '@mui/material'
import { Trans } from 'react-i18next'

/** USers read write permission step */
export const UsersReadWriteSteps: React.FC = () => {
  return (
    <>
      <Trans i18nKey="emobility.tour.user-permission-read-write" components={{ strong: <strong /> }} />
      <Box ml={2} mt={2}>
        <Trans i18nKey="emobility.tour.user-permission-read-write-tariffs" components={{ strong: <strong /> }} />
      </Box>
      <Box ml={2} mt={2}>
        <Trans i18nKey="emobility.tour.user-permission-read-write-wallboxes" components={{ strong: <strong /> }} />
      </Box>
    </>
  )
}
